// src/redux/slices/invoiceDrawerSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { labs } from "lobbie";
import { ELabsVendorType } from "src/types/global_enums";

export interface ILabsGlobalConfigState {
    vendorType?: ELabsVendorType;
    labTestComponentsGlobal?: labs.ILabTestComponentGlobal[];
    lastUpdated?: number;
}

export const initialStateLabsGlobalConfigState: ILabsGlobalConfigState = {
    vendorType: undefined,
    labTestComponentsGlobal: undefined,
    lastUpdated: undefined,
};

const labsGlobalConfigSlice = createSlice({
    name: "labsGlobalConfig",
    initialState: initialStateLabsGlobalConfigState,
    reducers: {
        setLabsGlobalConfigState: (state, action: PayloadAction<ILabsGlobalConfigState>) => {
            return {
                // ...initialStateLabsGlobalConfigState,
                lastUpdated: dayjs().valueOf(),
                // want to clear out the previous state
                ...action.payload,
            };
        },
        resetLabsGlobalConfigState: () => initialStateLabsGlobalConfigState,
    },
});

export const { setLabsGlobalConfigState, resetLabsGlobalConfigState } =
    labsGlobalConfigSlice.actions;
export default labsGlobalConfigSlice.reducer;
